import { useMemo, useCallback } from "react";
import DOMPurify from "dompurify";

import styles from "./Answer.module.css";

import {ResponseChoice, ResponseSourceDocuments, getDocumentApi} from "../../api";
import { parseAnswerToHtml } from "./AnswerParser";
import SourceIcon from "../../assets/source.svg?react"
import { Space } from "antd";
import { useAuth } from "../../Auth/AuthContect";

interface Props {
    answer: ResponseChoice;
    isSelected?: boolean;
    isStreaming: boolean;
}

export const Answer = ({
    answer,
    isStreaming,
}: Props) => {
    const { authToken } = useAuth();
    const messageContent = answer.message?.content || '';
    const sourceDocuments: ResponseSourceDocuments[] =  Array.from(new Set(answer?.source_documents?.map(obj => obj?.filename)))?.map(value => answer?.source_documents?.find(obj => obj?.filename === value)).filter(Boolean)  as ResponseSourceDocuments[]
    const parsedAnswer = useMemo(() => parseAnswerToHtml(messageContent, isStreaming), [answer]);
    const sanitizedAnswerHtml = DOMPurify.sanitize(parsedAnswer.answerHtml);

    const handleFilenameClick = useCallback(async (filename: string) => {
        if (!authToken) return;
        try {
            const response = await getDocumentApi(filename, authToken);
            if (!response.ok) {
                console.error('Error fetching document:', response.statusText);
                return;
            }
            const data = await response.json();
            if (data.download_url) {
                window.open(data.download_url, '_blank');
            } else {
                console.error('No download_url in response');
            }
        } catch (error) {
            console.error('Error fetching document:', error);
        }
    }, [authToken]);

    return (
        <Space className={`${styles.answerContainer}`} direction={"vertical"}>
                <div className={styles.answerText} dangerouslySetInnerHTML={{ __html: sanitizedAnswerHtml }}></div>

            {!!sourceDocuments?.length && (
                <div>
                    <Space direction={"vertical"}>
                        <div className={styles.citationLearnMore}>Citations:</div>
                        <Space direction="horizontal" className={styles.sourceDocumentsWrapper}>
                            {!!sourceDocuments?.length && sourceDocuments?.map((x: ResponseSourceDocuments, i) => {
                                return (
                                    <div key={i} className={styles.sourceDocumentsItem}>
                                        <SourceIcon/>
                                        <span
                                            className={styles.citation}
                                            onClick={() => handleFilenameClick(x.filename)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {x.filename}
                                        </span>
                                    </div>

                                );
                            })}
                        </Space>
                    </Space>
                </div>
            )}
        </Space>
    );
};
